import { render, staticRenderFns } from "./email-template-widget.vue?vue&type=template&id=2afa714e&scoped=true&"
import script from "./email-template-widget.vue?vue&type=script&lang=js&"
export * from "./email-template-widget.vue?vue&type=script&lang=js&"
import style0 from "./email-template-widget.vue?vue&type=style&index=0&id=2afa714e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afa714e",
  null
  
)

export default component.exports